export default function (store) {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault()
    store.commit('setInstallPromptEvent', event)
  })
}
